export const PAYRUN_COMPONENTS = {
  AMENDMENT_CREATE: 'payrunAmendmentCreate',
  AMENDMENT_SUBMIT: 'payrunAmendmentSubmit',
  AMENDMENT_DELETE: 'payrunAmendmentDelete',
  AMENDMENT_EDIT: 'payrunAmendmentEdit',
  APPROVE: 'payrunApprove',
  REJECT: 'payrunReject',
  PAYRUN_CREATE: 'payrunCreate',
} as const;
